import 'whatwg-fetch';
import Cookies from 'js-cookie';

class SessionService {
   
    isSessionValid() {

    	let promise = new Promise( function(resolve, reject) {

    		fetch('/session-service/api/v1/session/User',
                        {   credentials: "same-origin",
                            headers: {"XSRF_TOKEN": Cookies.get('XSRF_TOKEN')}
                        }).then(function (response) {
                             return response.json();
                        }).then(function (data) {
                            resolve(data);
                        }).catch(function(failure) {
                			reject(false);
                        })
        });
       	return promise;			      	
    }


}
export default SessionService;